import API from '../api'
import convertPagableData from '../convertPagableData'
import getUrl from './paths'

export const getShipmentRequestByIdApi = (shipmentRequestId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getShipmentRequestById, { shipmentRequestId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllShipmentsByRMApi = (userId, page = 0, size = 10, shipmentFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllShipmentsByRM, { userId, page, size, ...shipmentFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getShipmentRequestDraftApi = (orderId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getShipmentRequestDraft, { orderId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getShipmentRequestsByOrderIdApi = (orderId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getShipmentRequestsByOrderId, { orderId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getShipmentRequestSupplyResponseDraftApi = (shipmentRequestId, supplierPoNumber) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getShipmentRequestSupplyResponseDraft, { shipmentRequestId, supplierPoNumber })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getShipmentRequestSupplyResponseApi = (shipmentRequestId, fulfillmentPlanId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getShipmentRequestSupplyResponse, { shipmentRequestId, fulfillmentPlanId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

// filter is not used yet, so it is always sent as null
export const getApprovedFulfillmentPlansApi = (params = {}, filters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getApprovedFulfillmentPlans, { ...params, ...filters })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllFulfillmentPlansApi = (userId, page = 0, size = 10, fulfillmentPlanFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllFulfillmentPlans, { userId, page, size, ...fulfillmentPlanFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getDispatchPlanDraftApi = (fulfillmentPlanId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getDispatchPlanDraft, { fulfillmentPlanId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getFulfillmentPlanByIdApi = (fulfillmentPlanId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getFulfillmentPlanById, { fulfillmentPlanId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
